export default "__VITE_ASSET__BrkuAMy6__"